<div class="area"></div>
<nav class="main-menu hide-small" #stickyMenu [class.sticky]="sticky" id="openRight" (mouseenter)='over()'
  (mouseleave)='out()' *ngIf="isNotDMPAdmin">
  <ul id="myDIV">
    <li class="has-subnav" style="margin-top: 10px;">
      <a routerLinkActive="active" routerLink="{{pageContent.sideMenu?.list[0]?.routerLink}}"
        [ngClass]="{'active': homeRouteActive()}"
        (click)="commonFunction(pageContent.sideMenu?.list[0]?.function,pageContent.sideMenu?.list[0]?.parameter)">
        <i class="fa fa-2x"> <img src="{{pageContent.sideMenu?.list[0]?.image}}" style="Width:30px; height: 30px;"></i>
        <span class="nav-text">
          {{pageContent.sideMenu.list[0].content}}
        </span>
      </a>
    </li>
    <li *ngIf="showRegisterIcon" class="has-subnav listmargin" [ngClass]="{'active': enrollRouteActive()}">
      <a href="javascript:void(0);" routerLinkActive="active"
        (click)="commonFunction(pageContent.sideMenu?.list[1]?.function,pageContent.sideMenu?.list[1]?.parameter);">
        <i class="fa fa-2x"> <img src="{{pageContent.sideMenu?.list[1]?.image}}" style="Width:30px; height: 30px;"></i>
        <span class="nav-text">
          {{pageContent.sideMenu?.list[1]?.content}}
        </span>
      </a>

    </li>
    <li *ngIf="showDevicesIcon" class="has-subnav listmargin">
      <a routerLink="{{pageContent.sideMenu?.list[2]?.routerLink}}" routerLinkActive="active"
        (click)="commonFunction(pageContent.sideMenu?.list[2]?.function,pageContent.sideMenu?.list[2]?.parameter)">
        <i class="fa fa-2x"> <img src="{{pageContent.sideMenu?.list[2]?.image}}" style="Width:30px; height: 30px;"></i>
        <span class="nav-text">
          {{pageContent.sideMenu?.list[2]?.content}}
        </span>
      </a>
    </li>
    <!-- Adding False flag as a part of US-1367 -->
    <li *ngIf="false" class="has-subnav listmargin" [ngClass]="{'active': learnRouteActive()}">
      <a routerLink="{{pageContent.sideMenu.list[3].routerLink}}" 
        routerLinkActive="active" style="width: 194px !important;"
        (click)="commonFunction(pageContent.sideMenu?.list[3]?.function,pageContent.sideMenu?.list[3]?.parameter)">
        <i class="fa fa-2x"> <img src="{{pageContent.sideMenu?.list[3]?.image}}"
            style="height: 30px; padding-left : 13px"></i>
        <span class="nav-text" style="padding-left: 14px;">
          {{pageContent.sideMenu?.list[3]?.content}}
        </span>
      </a>
    </li>
    <!-- style="padding: 8px;" -->
    <!-- <li class="has-subnav fa-2x">
      <span>
        <img [style.display]="openDropMenu ? '' : 'none'" id='show' class="dropdownMenu" style="padding: 10px;"
          src="assets/img/dropdownMenu.png" alt="image icon for openDropMenu" (click)="openCloseSubMenu('show');" />
        <img [style.display]="closeDropMenu ? '' : 'none'" id='hide' class="dropdownMenu" style="padding: 10px;"
          src="assets/img/closeDropDown.png" alt="image icon for closeDropDown" (click)="openCloseSubMenu('hide');" />
      </span>
    </li> -->
    <ul class="fa fa-2x" *ngIf="false && display">
      <li class="has-subnav">
        <a (click)="checkSlider(pageContent.sideMenu.list[3].subMenu[0].routerLink,pageContent.sideMenu.list[3].subMenu[0].content)"
          routerLinkActive="active">
          <i class="fa fa-2x"></i>
          <span class="nav-text" style="padding-right: 10%;">
            {{pageContent.sideMenu?.list[3]?.subMenu[0]?.content}}
          </span>
        </a>
      </li>
      <li class="has-subnav ">
        <a (click)="checkSlider(pageContent.sideMenu?.list[3]?.subMenu[1]?.routerLink,pageContent.sideMenu?.list[3]?.subMenu[1]?.content)"
          routerLinkActive="active">
          <i class="fa fa-2x"></i>
          <span class="nav-text" style="padding-right: 3%; padding-bottom: 6px;">
            {{pageContent.sideMenu?.list[3]?.subMenu[1]?.content}}
          </span>
        </a>
      </li>
      <li class="has-subnav" style="text-align: initial;">
        <a (click)="checkSlider(pageContent.sideMenu?.list[3]?.subMenu[2]?.routerLink,pageContent.sideMenu?.list[3]?.subMenu[2]?.content)"
          routerLinkActive="active">
          <i class="fa fa-2x"></i>
          <span class="nav-text" style="padding-left: 14px;">
            {{pageContent.sideMenu?.list[3]?.subMenu[2]?.content}}
          </span>
        </a>
      </li>
      <!-- <li *ngIf="show5gOption" class="has-subnav" style="text-align: initial;">
        <a href="javascript:void(0);" [aria-label]="pageContent.sideMenu?.list[3]?.subMenu[3]?.content" (click)="checkSlider(pageContent.sideMenu?.list[3]?.subMenu[3]?.routerLink,pageContent.sideMenu?.list[3]?.subMenu[3]?.content)"
          routerLinkActive="active">
          <i class="fa fa-2x"></i>
          <span class="nav-text" style="padding-left: 14px;">
            {{pageContent.sideMenu?.list[3]?.subMenu[3]?.content}}
          </span>
        </a>
      </li> -->
    </ul>
    <!-- <li class="has-subnav listmargin">
      <a routerLink="{{pageContent.sideMenu.list[4].routerLink}}" routerLinkActive="active"
        (click)="commonFunction(pageContent.sideMenu?.list[4]?.function,pageContent.sideMenu?.list[4]?.parameter)">
        <i class="fa fa-2x"> <img src="{{pageContent.sideMenu?.list[4]?.image}}" style="Width:30px; height: 30px;"></i>
        <span class="nav-text">
          {{pageContent.sideMenu?.list[4]?.content}}
        </span>
      </a>
    </li> -->
    <li class="has-subnav listmargin" [ngClass]="{'active': supportsRouteActive()}">
      <a routerLink="{{pageContent.sideMenu.list[5].routerLink}}" routerLinkActive="active"
        (click)="commonFunction(pageContent.sideMenu?.list[5]?.function,pageContent.sideMenu?.list[5]?.parameter)">
        <i class="fa fa-2x"> <img src="{{pageContent.sideMenu?.list[5]?.image}}" style="Width:30px; height: 30px;"></i>
        <span class="nav-text">
          {{pageContent.sideMenu?.list[5]?.content}}
        </span>
      </a>
    </li>
    <hr style="border-top: 2px solid whitesmoke;">
    <li class="has-subnav listmargin">
      <a href="{{pageContent.sideMenu.list[7].href}}"
        (click)="commonFunction(pageContent.sideMenu?.list[7]?.function,pageContent.sideMenu?.list[7]?.parameter)">
        <i class="fa fa-2x"> <img src="{{pageContent.sideMenu?.list[7]?.image}}" style="Width:30px; height: 30px;"></i>
        <span class="nav-text">
          {{pageContent.sideMenu?.list[7]?.content}}
        </span>
      </a>
    </li>
    <li class="has-subnav listmargin">
      <a href="{{pageContent.sideMenu.list[8].href}}"
        (click)="commonFunction(pageContent.sideMenu?.list[8]?.function,pageContent.sideMenu?.list[8]?.parameter)">
        <i class="fa fa-2x"> <img *ngIf="pageContent.sideMenu?.list[8]?.image"
            src="{{pageContent.sideMenu?.list[8]?.image}}" style="Width:30px; height: 30px;"></i>
        <span class="nav-text">
          {{pageContent.sideMenu?.list[8]?.content}}
        </span>
      </a>
    </li>
    <li class="has-subnav listmargin">
      <span>
        <i class="fa fa-2x"> <img [style.display]="showMenuImg ? '' : 'none'" id='showMenu'
            src="assets/img/arrow_forward.png" alt="image icon for openDropMenu"
            (click)="openCloseSubMenu('showMenu');" /></i>
        <i class="fa fa-2x"> <img [style.display]="hideMeuImg ? '' : 'none'" id='hideMenu' style="max-width: 155px !important; height: 40px !important; margin-top: 13px !important;
            margin-left:-15px" src="assets/img/Hide_Side_Bar_Button.png" alt="image icon for closeDropDown"
            (click)="openCloseSubMenu('hideMenu');" /></i>
      </span>
    </li>
  </ul>
</nav>